export const serviceSso = 'https://sso.mm-api.agency/';
export const serviceToken = serviceSso+'oauth/token';